/**
 * Схлопування відкритої секції акордеона табів товару.
 *
 * Самі таби — радіогрупа без JS (див. sections/tg-product-tabs.liquid): на десктопі
 * це ряд табів, на мобільному — акордеон. Радіогрупа за визначенням тримає відкритою
 * рівно одну панель і зняти вибір кліком не дає — а в акордеоні повторний клік по
 * заголовку має секцію закривати.
 *
 * Тому єдине, що робить цей файл: на ширині акордеона перехоплює клік по вже
 * вибраному заголовку й знімає позначку. Решта — і перемикання, і клавіатура —
 * лишається штатною поведінкою радіогрупи.
 */

(() => {
  /* Один об'єкт на весь файл, а не `matchMedia()` у кожній функції: кожен виклик
     повертає НОВИЙ MediaQueryList, і слухач, повішений на анонімний об'єкт, ні з чим
     не пов'язаний — його нікому не тримати. */
  const accordion = window.matchMedia('(max-width: 749px)');

  /** Ширина акордеона: нижче 750 ряд табів розчиняється (`display: contents`). */
  const isAccordion = () => accordion.matches;

  document.addEventListener('click', (event) => {
    if (!isAccordion()) return;

    const label = event.target instanceof Element ? event.target.closest('.tg-tabs__tab') : null;
    if (!label) return;

    const radio = document.getElementById(label.getAttribute('for'));
    if (!(radio instanceof HTMLInputElement) || !radio.checked) return;

    // Клік по відкритій секції — закриваємо її, а не перевідкриваємо.
    event.preventDefault();
    radio.checked = false;
  });

  /* Повернення на десктопну ширину: якщо всі секції лишились схлопнутими, ряд табів
     стояв би без активного таба й без панелі. Відновлюємо перший.
     Реальний шлях сюди — поворот телефона: 414 у портреті проти 896 у ландшафті,
     тобто межа 750 таки перетинається.
     Слухаємо `resize`, а не `change` на MediaQueryList: подія та сама за наслідком,
     але її можна відтворити в тесті — до MQL, схованого в замиканні, ззовні не
     дістатись, і перевірити цю гілку в браузері було б нічим. */
  window.addEventListener('resize', () => {
    if (isAccordion()) return;

    document.querySelectorAll('.tg-tabs').forEach((tabs) => {
      const radios = tabs.querySelectorAll('.tg-tabs__radio');
      const hasChecked = Array.from(radios).some((radio) => radio.checked);
      if (radios.length > 0 && !hasChecked) radios[0].checked = true;
    });
  });
})();
